import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectUserCanManageIntegrations } from 'app/store/users';
import {
    doToggleIntegrationUnconfiguredDialog,
    selectIsIntegrationUnconfiguredDialogOpen
} from 'app/store/integrations/google';
import { IntegrationUnconfiguredDialog } from './IntegrationUnconfiguredDialog.jsx';

const mapStateToProps = createStructuredSelector({
    isOpen: selectIsIntegrationUnconfiguredDialogOpen,
    canUserManageIntegrations: selectUserCanManageIntegrations
});

const mapDispatchToProps = {
    onToggleDialog: doToggleIntegrationUnconfiguredDialog
};

export const IntegrationUnconfiguredDialogContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(IntegrationUnconfiguredDialog);
